module.exports = __webpack_public_path__ + "static/how-will-the-office-evolve-6e153506df3883dcefca72880887d656.png";